<h1 id="title" class="title">Sign In</h1>
<!--<p class="sub-title">Xin chào! Vui lòng đăng nhập.</p>-->

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Sorry!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Yay!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label class="label" for="input-email">Email / phone number:</label>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.email"
      #email="ngModel"
      name="email"
      id="input-email"
      pattern="(.+@.+\..+)|(\d+)"
      placeholder="Email | phone number"
      fieldSize="giant"
      autofocus
      [status]="email.dirty ? (email.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.email.required')"
      [attr.aria-invalid]="email.invalid && email.touched ? true : null"
    />
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="caption status-danger" *ngIf="email.errors?.required">This field is required!</p>
      <p class="caption status-danger" *ngIf="email.errors?.pattern">Incorrect format!</p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <span class="label-with-link">
      <label class="label" for="input-password">Password:</label>
      <!--      <a class="forgot-password caption-2" routerLink="../request-password">Forgot password?</a>-->
    </span>
    <input
      nbInput
      fullWidth
      [(ngModel)]="user.password"
      #password="ngModel"
      name="password"
      type="password"
      id="input-password"
      placeholder="Password"
      fieldSize="giant"
      [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.password.required')"
      [minlength]="getConfigValue('forms.validation.password.minLength')"
      [maxlength]="getConfigValue('forms.validation.password.maxLength')"
      [attr.aria-invalid]="password.invalid && password.touched ? true : null"
    />
    <ng-container *ngIf="password.invalid && password.touched">
      <p class="caption status-danger" *ngIf="password.errors?.required">This field is required!</p>
      <!--      <p class="caption status-danger" *ngIf="password.errors?.minlength || password.errors?.maxlength">-->
      <!--        Mật khẩu phải từ {{ getConfigValue('forms.validation.password.minLength') }} đến-->
      <!--        {{ getConfigValue('forms.validation.password.maxLength') }}-->
      <!--        ký tự-->
      <!--      </p>-->
    </ng-container>
  </div>

  <div class="form-control-group accept-group">
    <nb-checkbox name="rememberMe" [(ngModel)]="user.rememberMe" *ngIf="rememberMe">Remember me </nb-checkbox>
  </div>

  <div class="row">
    <div class="col text-center">
      <button nbButton status="info" size="large" [disabled]="submitted || !form.valid" [class.btn-pulse]="submitted">
        Sign In
      </button>
    </div>
  </div>
</form>

<!--<section class="links" aria-label="Social sign in">-->
<!--  hoặc đăng nhập bằng:-->
<!--  <div class="socials">-->
<!--    <ng-container>-->
<!--      <a href="{{ googleLink }}">-->
<!--        <nb-icon class="google"></nb-icon>-->
<!--      </a>-->
<!--      &lt;!&ndash;      <a href="{{ facebookLink }}">&ndash;&gt;-->
<!--      &lt;!&ndash;        <nb-icon class="facebook"></nb-icon>&ndash;&gt;-->
<!--      &lt;!&ndash;      </a>&ndash;&gt;-->
<!--      &lt;!&ndash;      <a href="{{ appleLink }}">&ndash;&gt;-->
<!--      &lt;!&ndash;        <nb-icon class="apple"></nb-icon>&ndash;&gt;-->
<!--      &lt;!&ndash;      </a>&ndash;&gt;-->
<!--    </ng-container>-->
<!--  </div>-->
<!--</section>-->

<!--<section class="another-action" aria-label="Register">-->
<!--  Bạn chưa có tài khoản? <a class="text-link" routerLink="../register">Đăng ký</a>-->
<!--</section>-->
